import React from "react";

export const Callback = () => {
  return (
    <div className="slide-spinner">
      <img className="progress-row-spinner" alt="spinner" src="./images/spinner.svg" />
    </div>
  );
};